import { ReactComponent as GsonSvg } from "assets/import-geon.svg";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppAction, AppContext } from "helpers/context";
import {
  parseGeoJsonFile,
  ParseGeoJsonResult,
  ParseGeoJsonError
} from "./parseGeoJsonFile";
import styles from "./import-modal.module.scss";

interface ImportWitgetProps {
  onParsedSuccess: (data: ParseGeoJsonResult) => void;
}

const ImportWitget: React.FC<ImportWitgetProps> = ({ onParsedSuccess }) => {
  const [t] = useTranslation();
  const [, dispatch] = useContext(AppContext);
  const [loading, setLoading] = useState(false);

  const handleChangeUploadFile = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLoading(true);

    parseGeoJsonFile(
      file,
      (data: ParseGeoJsonResult) => {
        onParsedSuccess(data);
        setLoading(false);
        event.target.value = "";
      },
      (error: ParseGeoJsonError) => {
        dispatch({
          type: AppAction.addSnackBarParams,
          payload: {
            titleIcon: "error",
            titleIconColor: "red",
            title: error.title,
            message: error.message
          }
        });
        setLoading(false);
        event.target.value = "";
      }
    );
  };

  return (
    <div className={styles.modal}>
      <input
        className={styles.uploadIpt}
        type="file"
        accept=".geojson"
        onClick={(e) => e.stopPropagation()}
        onChange={handleChangeUploadFile}
      />

      <div className={styles.import}>
        <div className={styles.upload}>
          <GsonSvg className={styles.icon} />
          <div className={styles.text2}>
            <div className={styles.text1}>{t("myShapes.modal-gson.title")}</div>
            &nbsp;
            <div className={styles.text1} style={{ color: "green" }}>
              {t("myShapes.modal-gson.text1")}
            </div>
            &nbsp;
            <div className={styles.text1}>{t("myShapes.modal-gson.text2")}</div>
          </div>
          <div className={styles.text2}>
            <div>{t("myShapes.modal-gson.text3")}</div>
          </div>
        </div>

        {loading && (
          <div className="loading loading-spinner" style={{ color: "#666" }} />
        )}
      </div>
    </div>
  );
};

export default ImportWitget;
